import {Fragment, useContext} from "react";
import {useNavigate} from "react-router-dom";
import {GlobalContext} from "../admin-frame/AdminFrame";
import {ApiUtility} from "../common/ApiUtility";
import {AuthUtility} from "../common/AuthUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {Constants} from "../common/Constants";
import {useModelCreateEngine} from "../common/hooks/useModelCreateEngine";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {UserForm} from "./UserForm";

export let CreateUserPage = function () {
    if (!AuthUtility.userHasEnforcedPermissions([Constants.permissionNames.userCreate])) return null;
    const context = useContext(GlobalContext);
    const modelCreateEngine = useModelCreateEngine(
        ApiUtility.createUser,
        'user',
        () => context.navigator.goBack(),
        'invited',
        'inviting'
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelCreateEngine.dataStore.data().loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <UserForm
                save={modelCreateEngine.createModel}
                cancel={() => context.navigator.goBack()}
                isNew={true}
            />
        </Fragment>
    );
};
